/** Human-readable names for audit actions. Unknown actions fall back to a tidied key. */
export const ACTION_LABELS: Record<string, string> = {
  'auth.login': 'Sign-in',
  'auth.logout': 'Sign-out',
  'auth.password_changed': 'Password change',
  'auth.account_locked': 'Account lock',
  'business.created': 'Business setup',
  'business.settings_updated': 'Settings change',
  'branch.created': 'New branch',
  'branch.updated': 'Branch change',
  'role.created': 'New role',
  'role.updated': 'Role change',
  'role.deleted': 'Role deletion',
  'user.created': 'New staff account',
  'user.updated': 'Staff change',
  'user.deactivated': 'Staff deactivation',
  'user.password_reset': 'Password reset',
  'user.unlocked': 'Account unlock',
  'user.sessions_revoked': 'Forced sign-out',
};

export const ACTION_FILTERS: { value: string; label: string }[] = [
  { value: '', label: 'All activity' },
  { value: 'auth.', label: 'Sign-ins and passwords' },
  { value: 'user.', label: 'Staff accounts' },
  { value: 'role.', label: 'Roles and permissions' },
  { value: 'branch.', label: 'Branches' },
  { value: 'business.', label: 'Business settings' },
];

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action.replace(/[._]/g, ' ');
}
